<script lang="ts">

import { defineComponent, InjectionKey } from 'vue'

export interface PageLayoutPublicInstance {}

export const pageLayoutInjectionKey: InjectionKey<PageLayoutPublicInstance> = Symbol('page-layout')

export default defineComponent({
  name: 'PageLayout',
  components: { },
  setup () {
    return {
    }
  }
})
</script>

<template>
  <div class="layout w-full h-sview max-h-lview relative overflow-hidden">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.layout {
  background-color: $c-black;
}

</style>
